import { createRoot } from 'react-dom/client';
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup,
    Export,
    HeaderFilter
} from 'devextreme-react/data-grid';
import LoadIndicator from 'devextreme-react/load-indicator';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { Link, useNavigate } from 'react-router-dom';
import TabPanel, { Item } from "devextreme-react/tab-panel";
import axios from 'axios';
import { backendlink } from '../../config';
import SciChartExample from './scichart';
import ECGGraphPlot from './ECGGraphPlot';
import ECGScatterPlot from './ECGScatterPlot';
import DataSource from 'devextreme/data/data_source';

import WaveSurfer from 'wavesurfer.js'
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.esm.js'

import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';

import {
    NumericAxis,
    SciChartSurface,
    XyDataSeries,
    EllipsePointMarker,
    XyScatterRenderableSeries,
    EAxisAlignment,
    ETitlePosition,
    ETextAlignment,
    SciChartJsNavyTheme,
    ZoomPanModifier,
    VerticalLineAnnotation,
    HorizontalLineAnnotation,
    EAutoRange,
    visibleRange
} from "scichart";
import { DpiHelper } from 'scichart/Charting/Visuals/TextureManager/DpiHelper';
import ReactDOM from 'react-dom';
import IntervalChart from './IntervalChart';
import ScatterPlot from './ScatterPlot';
import FiveMinIntervalChart from './FiveMinIntervalChart';

export default function DoctorPatientECGDatagrid() {

    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [patientToken, setPatientToken] = useState("");
    const [linkedCustomerName, setLinkedCustomerName] = useState('');
    const [linkedCustomerID, setLinkedCustomerID] = useState('');
    const [linkedDoctorName, setLinkedDoctorName] = useState('');
    const [patientName, setPatientName] = useState('');
    const [messages, setMessages] = useState([]);
    const [waveform, setWaveform] = useState([]);
    const [waveformIsOn, setWaveformIsOn] = useState([]);
    const [pageSize, setPageSize] = useState(5);
    const [pageIndex, setPageIndex] = useState(0);

    const [record, setRecord] = useState([]); // State to hold the record data

    const [popupVisible, setPopupVisible] = useState(false); // State to control popup visibility

    const [FiveMinIntervalID, setFiveMinIntervalID] = useState(null);
    const [ECGDataID, setECGDataID] = useState(null);
    const popupRef = useRef(null); // Reference for the popup container
    const [popupSize, setPopupSize] = useState({ width: '85vw', height: '80vh' }); // State to control popup size

    const openPopup = () => {
        setPopupVisible(true); // Set popup visibility to true
    };

    const closePopup = () => {
        setFiveMinIntervalID(null);
        setECGDataID(null);
        setPopupVisible(false); // Set popup visibility to false
    };

    const containerRef = useRef(null);
    const sciChartSurfaceRef = useRef(null);
    SciChartSurface.useWasmFromCDN();

    function formatDuration(durationInMs) {
        const totalSeconds = Math.floor(durationInMs);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        let formattedDuration = '';
        if (hours > 0) {
            formattedDuration += `${hours}h `;
        }
        if (minutes > 0) {
            formattedDuration += `${minutes}m `;
        }
        if (seconds > 0 || formattedDuration === '') {
            formattedDuration += `${seconds}s`;
        }

        return formattedDuration.trim();
    }

    function formatLocalDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        const second = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hour}:${minute}:${second}`.toUpperCase();
    }

    const fetchMessage = async (loadOptions) => {
        try {
            const page = Math.floor(loadOptions.skip / loadOptions.take) + 1;
            const size = loadOptions.take;

            console.log("Load Options:", loadOptions);
            console.log("Page:", page, "Size:", size);

            // Extract sorting parameters from loadOptions
            const sortBy = loadOptions.sort?.[0]?.selector || 'Date'; // Default to 'Date' if no sort is provided
            const sortOrder = loadOptions.sort?.[0]?.desc !== undefined ? (loadOptions.sort[0].desc ? 'desc' : 'asc') : 'desc'; // Default to 'desc'            console.log("Sort By:", sortBy, "Sort Order:", sortOrder);

            const response = await axios.post(backendlink + 'doctor/getpatientecgrecords',
                {
                    patienttoken: location.state.patientToken,
                    page: page,
                    size: size,
                    sortBy: sortBy,
                    sortOrder: sortOrder
                },
                {
                    headers: {
                        token: user.token
                    }
                });

            console.log("response", response)

            if (response.data.errorno == 0) {
                const outputArray = response.data.result.map(item => ({
                    uid: item.id,
                    // sharedDate: new Date(item.sharedDate * 1000).toISOString().replace('T', ' ').replace('Z', '').slice(0, 19),
                    // recordDate: new Date(item.recordedDate * 1000).toISOString().replace('T', ' ').replace('Z', '').slice(0, 19),
                    // sharedDate: item.sharedDate === null ? null : formatLocalDate(new Date(item.sharedDate * 1000)),
                    // recordDate: item.recordedDate === null ? null : formatLocalDate(new Date(item.recordedDate * 1000)),
                    // recordType: item.recordType.toUpperCase(),
                    // recordDuration: formatDuration(item.recordDuration),
                    // aiResult: item.noOfRisks + ' Abnormal Found',
                    // bpm: item.bpm + ' BPM',
                    Date: item.date,
                    // recordDuration: formatDuration(item.duration),
                    recordDuration: item.duration === -1 ? "0s" : formatDuration(item.duration), // Show "0s" for duration when backend returns -1
                    noOfRisks: item.noOfRisks,
                    // aveHR: Math.floor(item.avrHr) + ' bpm',
                    // maxHR: Math.floor(item.maxHr) + ' bpm',
                    // minHR: Math.floor(item.minHr) + ' bpm',
                    aveHR: item.avrHr === -1 ? "N/A" : Math.floor(item.avrHr) + " BPM", // Show "N/A" for average HR when backend returns -1
                    maxHR: item.maxHr === -1 ? "N/A" : Math.floor(item.maxHr) + " BPM", // Show "N/A" for max HR when backend returns -1
                    minHR: item.minHr === -1 ? "N/A" : Math.floor(item.minHr) + " BPM", // Show "N/A" for min HR when backend returns -1
                }));

                // console.log("Fetched Data:", outputArray);
                console.log("Total Count:", response.data);

                return {
                    data: outputArray,
                    totalCount: response.data.meta.total,
                };
            } else {
                throw new Error(response.data.errmessage);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    };

    const [dataSource] = useState(new DataSource({
        load: fetchMessage,
    }));

    const fetchData = async () => {
        try {
            const response = await axios.post(backendlink + 'doctor/getpatient', {
                doctortoken: user.userToken,
                patienttoken: location.state.patientToken
            }, {
                headers: {
                    token: user.token
                }
            });

            if (response.data.errorno == 0) {
                const outputArray = response.data.result.map(item => {
                    setLinkedCustomerName(item.linkedcustomer);
                    setLinkedCustomerID(item.linkedcustomerid);
                    setLinkedDoctorName(item.linkeddoctor);
                    setPatientName(item.name);
                    fetchMessage({ skip: 0, take: pageSize });
                });
            } else {
                console.log(response.data.errmessage);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function getWaveformData(data) {
        const handleClick = (e) => {
            // e.preventDefault();
            setRecord(data);
            openPopup();
        };

        return (
            <button onClick={handleClick} style={{ backgroundColor: '#005CBB', color: 'white', padding: '10px 20px', borderRadius: '5px', border: "none", marginBottom: "10px", cursor: 'pointer' }}>
                View Details
            </button>
        );
    }

    const waveformCell = (cellData) => (
        <div>
            {getWaveformData(cellData.data)}
            <br />
        </div>
    );

    const handleSetFiveMinIntervalID = (id) => {
        if (FiveMinIntervalID != id) {
            setFiveMinIntervalID(id); // Set the FiveMinIntervalID
            setECGDataID(null); // Reset ECGDataID to null
        }

    };

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                setPopupSize({ width: `${width}px`, height: `${height}px` }); // Update popup size state
                console.log('Popup size changed:1', width, height);
                // Perform actions based on popup size changes
            }
        });

        // Ensure popupRef.current is a valid DOM element
        if (popupRef.current && popupRef.current instanceof HTMLElement) {
            resizeObserver.observe(popupRef.current); // Observe popup size changes
        } else {
            console.error('popupRef.current is not a valid DOM element');
        }

        return () => {
            if (popupRef.current && popupRef.current instanceof HTMLElement) {
                resizeObserver.unobserve(popupRef.current); // Cleanup observer
            }
        };
    }, [popupRef, popupVisible]);

    const DataRow = (rowInfo) => (
        <React.Fragment>
            <tr role="row">
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.Date}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.recordDuration}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.noOfRisks}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.aveHR}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.maxHR}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{rowInfo.data.minHR}</td>
                <td role="gridcell" style={{ paddingLeft: '16px', paddingRight: '16px' }}>{waveformCell(rowInfo)}</td>
            </tr>
            <tr className="waveform-row">
                {/* <td colSpan={3}>
                    <div id={"waveform-" + rowInfo.data.uid} style={{ width: "0px", height: "0px" }} />
                </td>
                <td colSpan={3}>
                    <div id={"ecg-" + rowInfo.data.uid} />
                </td> */}
                <td colSpan={9}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                        <div id={"waveform-" + rowInfo.data.uid} style={{ width: "0px", height: "0px" }} />
                        <div id={"ecg-" + rowInfo.data.uid} style={{ flex: '1 1 500px', height: "0px", margin: "10px" }} />
                    </div>
                </td>
            </tr>
        </React.Fragment>
    );

    useEffect(() => {
        if (location.state?.patientToken == null) {
            navigate('/');
        } else {
            setPatientToken(location.state.patientToken);
            fetchData();
        }
    }, [user]);

    return (
        <React.Fragment>
            <table className="custom-table">
                <thead>
                    <tr>
                        <th>Organization:</th>
                        <td>{linkedCustomerName}</td>
                        <th>Organization ID:</th>
                        <td>{linkedCustomerID}</td>
                        <th>Doctor:</th>
                        <td>{linkedDoctorName}</td>
                        <th>Patient:</th>
                        <td>{patientName}</td>
                    </tr>
                </thead>
            </table>

<DataGrid
    dataSource={dataSource}
    dataRowRender={DataRow}
    cacheEnabled={false}
    remoteOperations={true}
    style={{ textAlign: 'left' }}
>
    <Column
        dataField="Date"
        caption="Date"
        width="15%"
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Date
            </div>
        )}
    />
    <Column
        dataField="recordDuration"
        caption="Record Duration"
        width="15%"
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Record Duration
            </div>
        )}
    />
    <Column
        dataField="noOfRisks"
        caption="Number of Risk Detected"
        width="15%"
        alignment="left"
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Number of Risk Detected
                <br />
                (5-min intervals)
            </div>
        )}
    />
    <Column
        dataField="aveHR"
        caption="Average Heart Rate"
        width="15%"
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Average Heart Rate
            </div>
        )}
    />
    <Column
        dataField="maxHR"
        caption="Max Heart Rate"
        width="15%"
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Max Heart Rate
            </div>
        )}
    />
    <Column
        dataField="minHR"
        caption="Min Heart Rate"
        width="15%"
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Min Heart Rate
            </div>
        )}
    />
    <Column
        dataField="waveform"
        caption=""
        minWidth="120"
        width="15%"
        allowSorting={false}
        headerCellRender={() => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                Waveform
            </div>
        )}
    />
    <Pager allowedPageSizes={[5, 10]} showPageSizeSelector={true} />
    <Paging defaultPageSize={pageSize} defaultPageIndex={pageIndex} />
    <Lookup />
</DataGrid>

            <Popup
                visible={popupVisible}
                onHiding={closePopup}
                showTitle={false}
                dragEnabled={false}
                hideOnOutsideClick={true}
                maxWidth={1600}
                maxHeight={1158}
                minWidth={672}
                width={`85vw`} // Dynamically set width
                // height={`${window.innerHeight - 100}px`} // Dynamically set height
                height={`80vh`} // Dynamically set height
                ref={popupRef} // Attach ref to popup

            >
                <div ref={popupRef} // Attach ref to popup
                    style={{ height: '100%', overflow: 'auto' }}>
                    <span className='titles' style={{
                        marginBottom: '5px', marginTop: '0px',
                        textAlign: window.innerWidth < 1935 ? 'center' : 'left', // Center the text
                        display: 'block', // Ensure it behaves like a block element for centering
                    }}>ECG Record Details</span>
                    {/* Table for displaying record details */}
                    <table className="custom-table" style={{ width: '100%' }}>

                        <thead>
                            <tr>
                                <th className='text-bold-medium'>Date:</th>
                                <td className='text-bold-medium'>{record.Date}</td>
                                <th className='text-bold-medium'>Record Duration:</th>
                                <td className='text-bold-medium'>{record.recordDuration}</td>
                                <th className='text-bold-medium'>Number of Risk Detected (5-min intervals):</th>
                                <td className='text-bold-medium'>{record.noOfRisks}</td>
                            </tr>
                            <tr>
                                <th className='text-bold-medium'>Average Heart Rate:</th>
                                <td className='text-bold-medium'>{record.aveHR}</td>
                                <th className='text-bold-medium'>Max Heart Rate:</th>
                                <td className='text-bold-medium'>{record.maxHR}</td>
                                <th className='text-bold-medium'>Min Heart Rate:</th>
                                <td className='text-bold-medium'>{record.minHR}</td>
                            </tr>
                        </thead>
                    </table>
                    <br />


                    {/* Place IntervalChart and ScatterPlot on the same row */}
                    {/* {FiveMinIntervalChart && <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
                        <div style={{ width: "856px", backgroundColor: '#F9F9FF', padding: '10px', borderRadius: '5px' }}>
                            <IntervalChart setFiveMinIntervalID={setFiveMinIntervalID} record={record} user={user} patientToken={location.state.patientToken} />
                        </div>
                        <div style={{ width: "616px" }}>
                            <ScatterPlot uid={record.uid} patientToken={patientToken} user={user} setFiveMinIntervalID={setFiveMinIntervalID} />
                        </div>
                    </div>} */}
                    {FiveMinIntervalChart && (
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap', // Allow items to wrap to the next row
                                gap: '20px',
                                marginBottom: '20px',
                            }}
                        >
                            <div
                                style={{
                                    flex: '1 1 856px', // Allow the IntervalChart to take up to 856px
                                    // maxWidth: '856px', // Ensure it has a minimum width of 856px
                                    backgroundColor: '#F9F9FF',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    overflowX: 'auto',
                                }}
                            >
                                <IntervalChart
                                    FiveMinIntervalID={FiveMinIntervalID}
                                    setFiveMinIntervalID={handleSetFiveMinIntervalID}
                                    record={record}
                                    user={user}
                                    patientToken={location.state.patientToken}
                                    resetTrigger={!popupVisible} // Trigger reset when popup closes
                                />
                            </div>
                            <div
                                style={{
                                    flex: '1 1 616px', // Allow the ScatterPlot to take up to 616px
                                    // maxWidth: '616px', // Ensure it has a minimum width of 616px
                                    backgroundColor: '#F9F9FF',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    height: '440px',
                                }}
                            >

                                <ECGScatterPlot
                                    uid={record.uid}
                                    patientToken={patientToken}
                                    user={user}
                                    handleSetFiveMinIntervalID={handleSetFiveMinIntervalID}
                                    popupSize={popupSize} // Pass popup size to ScatterPlot
                                />
                            </div>
                        </div>
                    )}
                    <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', flexWrap: 'wrap' }}>
                        {!FiveMinIntervalID && <div style={{ textAlign: 'center', paddingTop: '120px', fontSize: '24px', fontWeight: 'bold', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', height: '100%', width: '100%' }}>
                            Select an interval above to see the details
                        </div>}
                        {FiveMinIntervalID && <div style={{ height: "446px", backgroundColor: '#F9F9FF', padding: '10px', borderRadius: '5px', flex: '1 1 440px' }}>
                            <FiveMinIntervalChart setECGDataID={setECGDataID} FiveMinIntervalID={FiveMinIntervalID} user={user} patientToken={patientToken} />
                        </div>}
                        <div style={{ flex: '1 1 1048px' }}>
                            {(!ECGDataID && FiveMinIntervalID) && (
                                <div style={{ height: '446px' }}>
                                    {/* Placeholder table */}
                                    <div className='titles' style={{ textAlign: 'left', width: '100%' }}>
                                        Selected ECG Graph
                                    </div>
                                    <table className='custom-table' style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px', textAlign: 'left' }}>
                                        <thead>
                                            <tr>
                                                <th className='text-bold-medium' style={{ border: '1px solid #ddd', padding: '8px' }}>Time:</th>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.sharedDate}</td>

                                                <th className='text-bold-medium' style={{ border: '1px solid #ddd', padding: '8px' }}>ECG Mode:</th>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.recordType}</td>
                                            </tr>
                                            <tr>
                                                <th className='text-bold-medium' style={{ border: '1px solid #ddd', padding: '8px' }}>Average Heart Rate:</th>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.bpm}</td>

                                                <th className='text-bold-medium' style={{ border: '1px solid #ddd', padding: '8px' }}>AF Probrability :</th>
                                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.aiResult}</td>
                                            </tr>
                                        </thead>
                                    </table>

                                    {/* Placeholder box */}
                                    <div className='titles'
                                        style={{
                                            display: 'flex', // Use Flexbox
                                            justifyContent: 'center', // Center horizontally
                                            alignItems: 'center', // Center vertically
                                            border: '1px solid #ddd',
                                            borderRadius: '5px',
                                            height: '324px',
                                            width: '100%',
                                        }}>
                                        Select a segment on the left to see the details
                                    </div>
                                </div>
                            )}
                            {ECGDataID && <ECGGraphPlot ECGDataID={ECGDataID} patientToken={patientToken} user={user} />}
                        </div>
                    </div>
                    <Button onClick={closePopup} style={{ backgroundColor: '#005CBB', color: 'white', }}>
                        Close
                    </Button>
                </div>
            </Popup>
        </React.Fragment>
    );
}